import React from 'react';
import AssistantIcon from '@material-ui/icons/Assistant';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectArrayInput,
    CustomSelectInput,
} from 'candy-commons-components';
import constants from 'candy-commons/constants';
import {
    ArrayInput,
    Edit,
    FormDataConsumer,
    SimpleForm,
    SimpleFormIterator,
    TextInput,
    useTranslate,
} from 'react-admin';
import CustomToolbar from '../../components/CustomToolbar';
import COUNTRIES from '../../data/countries.json';
import { useSelector } from 'react-redux';
import {
    getApplianceTypes,
    getBrands,
    getSeries,
} from '../../selectors/cmsConfig';
const EcoEvents = constants.EcoEvents;
const EnergyProviderEdit = ({ permissions = {}, ...props }) => {
    const translation = useTranslate();
    const isEditDisabled = !permissions?.['energy-provider']?.update;
    const { id, deepLink, appName } = props;
    const brands = useSelector(getBrands);
    const applianceTypes = useSelector(getApplianceTypes);
    const series = useSelector(getSeries);
    const breadcrumbsData = [
        {
            text: translation('resources.energy-provider.name'),
            url: 'energy-provider',
            icon: <AssistantIcon />,
        },
        {
            text: id,
            url: '',
        },
    ];
    const getFilteredEvents = (applianceType) => {
        if (applianceType) {
            applianceType = applianceType === 'WM-WD' ? 'WM' : applianceType;
            return EcoEvents.filter((evt) =>
                evt?.applianceTypes.includes(applianceType)
            );
        }
        return [];
    };
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit {...props}>
                <SimpleForm
                    redirect="list"
                    toolbar={<CustomToolbar permissions={permissions} />}
                >
                        <ContainerFieldsList>
                            <TextInput
                                id={id}
                                source="id"
                                label="Energy Provider Key"
                                disabled
                            />
                            <TextInput
                                deepLink={deepLink}
                                source="deepLink"
                                label="Deep Link"
                                disabled={isEditDisabled}
                            />
                            <TextInput
                                appName={appName}
                                source="appName"
                                label="App Name"
                                disabled={isEditDisabled}
                            />
                        </ContainerFieldsList>
                </SimpleForm>
            </Edit>
        </>
    );
};
export default EnergyProviderEdit;
